import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ProjectTheme } from "src/app/Models/ProjectTheme";

@Component({
    selector: "app-assistance",
    templateUrl: "./assistance.component.html",
    styleUrl: "./assistance.component.scss",
    standalone: false
})
export class AssistanceComponent {
  theme: ProjectTheme = "WUnivers";
  //public assistanceImg:'assets/admin-common/Rectangle 2.png'
  constructor(private router: Router) {}

  navigateTostores() {
    this.router.navigate(["/stores"]);
  }

  navigateToContacts() {
    this.router.navigate(["/contact"]);
  }

  sendEmail() {
    window.location.href = "mailto:contact@ekiclik.dz";
  }
}
